import React from 'react'
import Helmet from 'react-helmet'

import constants from 'config/constants'

interface TitleProps {
  title: string
}

/**
 * Sets the browser tab title using the Simplesat brand suffix
 * (e.g. `"Login | Simplesat"`).
 *
 * Use this on pages that don't render a visible PageHeader
 * (login, maintenance, error pages). For pages that render a
 * PageHeader, the title is set automatically via PageHeader.
 */
export default function Title({ title }: TitleProps) {
  return <Helmet title={`${title} ${constants.titleTag}`} />
}



// WEBPACK FOOTER //
// ./src/shared/components/Title/index.tsx